const TypeLabelMap: Record<string, string> = {
  '[Outreach] [Email] [Out]': 'Outbound Email',
  '[Outreach] [Email] [In]': 'Inbound Email',
  '[Email] [In]': 'Inbound Email',
  '[Email] [Out]': 'Outbound Email',
  'Opened Email:': 'Email Opened',
  'Clicked Link in Email:': 'Email Clicked',
  'Email:': 'Email',
  'Replied:': 'Email Reply',
  'Zoom:': 'Video Call'
}

const Types: string[] = Object.keys(TypeLabelMap)

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const getTaskTypeFromSubject = (subject: string): string | undefined => {
  const TypeTests = Types.map(str => ({
    match: new RegExp(escapeRegExp(str), 'gy'),
    value: TypeLabelMap[str]
  }))
  let type

  TypeTests.forEach(key => {
    if (key.match.test(subject)) {
      return (type = key.value)
    }
  })

  return type
}

export const removeTypeFromSubjectLine = (subject: string): string => {
  const TypeTests = Types.map(str => new RegExp(escapeRegExp(str), 'gy'))

  TypeTests.forEach(key => {
    subject = subject.replace(key, '').trim()
  })

  return subject
}
